import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { TaxedMoney } from "@components/containers";
import { Thumbnail } from "@components/molecules";
import { useProductDetails } from "@temp/@sdk/react";
import { reviewsUrl } from "@temp/app/routes";
import { Button, Loader, StatusProgress } from "@temp/components";
import { generateProductUrlWithAttributes } from "@temp/components/ProductDetails/utils";
import classNames from "classnames";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import downloadImg from "../../images/download.svg";
import { commonMessages } from "../../intl";
import { ProductListItemAttributes } from "../OverlayManager/Cart/ProductListItemAttributes";

var ProductRow = function ProductRow(_ref) {
  var _data$translation, _data$category$transl;

  var mediumScreen = _ref.mediumScreen,
      processing = _ref.processing,
      line = _ref.line;
  var intl = useIntl();

  var _useProductDetails = useProductDetails({
    id: line.product.id
  }),
      data = _useProductDetails.data,
      loading = _useProductDetails.loading;

  var productAttributesWithData = data ? line.selectedProductAttributes.map(function (attrString) {
    var _attributeData$attrib;

    var _attrString$split = attrString.split(" "),
        _attrString$split2 = _slicedToArray(_attrString$split, 2),
        attrName = _attrString$split2[0],
        _attrValue = _attrString$split2[1];

    var attrValue = _attrValue.replace(/[()]/g, "");

    var attributeData = data === null || data === void 0 ? void 0 : data.attributes.find(function (attr) {
      return attr.attribute.name === attrName;
    });
    var valuesData = attributeData === null || attributeData === void 0 ? void 0 : attributeData.values.filter(function (value) {
      return value.name === attrValue;
    });
    return {
      id: attributeData === null || attributeData === void 0 ? void 0 : attributeData.attribute.id,
      name: attributeData === null || attributeData === void 0 ? void 0 : attributeData.attribute.name,
      translatedName: attributeData === null || attributeData === void 0 ? void 0 : (_attributeData$attrib = attributeData.attribute.translation) === null || _attributeData$attrib === void 0 ? void 0 : _attributeData$attrib.name,
      values: valuesData === null || valuesData === void 0 ? void 0 : valuesData.map(function (value) {
        var _value$translation;

        return {
          name: value.name,
          translatedName: (_value$translation = value.translation) === null || _value$translation === void 0 ? void 0 : _value$translation.name
        };
      })
    };
  }) : [];
  var variantAttributesWithData = data ? line.attributes.map(function (item) {
    var _attributeData$transl;

    var attributeData = data === null || data === void 0 ? void 0 : data.productType.variantAttributes.find(function (attr) {
      return attr.id === item.attribute.id;
    });
    return {
      id: attributeData === null || attributeData === void 0 ? void 0 : attributeData.id,
      name: attributeData === null || attributeData === void 0 ? void 0 : attributeData.name,
      translatedName: attributeData === null || attributeData === void 0 ? void 0 : (_attributeData$transl = attributeData.translation) === null || _attributeData$transl === void 0 ? void 0 : _attributeData$transl.name,
      values: item.values.map(function (value) {
        var _value$translation2;

        return {
          name: value.name,
          translatedName: (_value$translation2 = value.translation) === null || _value$translation2 === void 0 ? void 0 : _value$translation2.name
        };
      })
    };
  }) : [];
  var allAttributes = useMemo(function () {
    return [].concat(_toConsumableArray(productAttributesWithData), _toConsumableArray(variantAttributesWithData));
  }, [productAttributesWithData, variantAttributesWithData]);
  var editUrl = useMemo(function () {
    var attributes = allAttributes.reduce(function (acc, cur) {
      var value = cur.values && cur.values[0];
      acc[cur.name] = value === null || value === void 0 ? void 0 : value.name;
      return acc;
    }, {});
    return generateProductUrlWithAttributes(line.product, attributes);
  }, [allAttributes, line.product]);

  if (loading) {
    return React.createElement(Loader, null);
  }

  if (!data) {
    return React.createElement("div", null, "no data");
  }

  return React.createElement("div", {
    className: "cart-table-row".concat(classNames({
      "cart-table-row--processing": processing
    }))
  }, React.createElement("div", {
    className: "cart-table-row__thumbnail"
  }, React.createElement("div", null, React.createElement(Thumbnail, {
    source: line.product
  }))), React.createElement("div", {
    className: "cart-table-row__data"
  }, React.createElement("div", {
    className: "cart-table-row__data-name"
  }, ((_data$translation = data.translation) === null || _data$translation === void 0 ? void 0 : _data$translation.name) || data.name), React.createElement("div", {
    className: "cart-table-row__data-price"
  }, React.createElement(TaxedMoney, {
    taxedMoney: line.pricing.price
  })), React.createElement("div", {
    className: "cart-table-row__data-status"
  }, React.createElement("div", null, React.createElement("div", {
    className: "status-block"
  }, React.createElement("span", {
    className: "label"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Door status",
    "id": "components.CartTable.ProductRow.40585757"
  }, "id", "components.CartTable.ProductRow.40585757"))), React.createElement("span", {
    className: "mobile-status"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "In progress",
    "id": "components.CartTable.ProductRow.2737619734"
  }, "id", "components.CartTable.ProductRow.2737619734")))), React.createElement(StatusProgress, null))), React.createElement("div", {
    className: "cart-table-row__data-parameters"
  }, React.createElement("div", null, React.createElement("span", {
    className: "label"
  }, "".concat(intl.formatMessage(commonMessages.category), ": "), React.createElement("span", {
    className: "info"
  }, ((_data$category$transl = data.category.translation) === null || _data$category$transl === void 0 ? void 0 : _data$category$transl.name) || data.category.name))), React.createElement("div", null, React.createElement(ProductListItemAttributes, {
    attributes: allAttributes,
    alwaysShowAll: true
  })), React.createElement("div", null, React.createElement("span", {
    className: "label"
  }, React.createElement("div", {
    className: "cart__list__item-shipping"
  }, "".concat(intl.formatMessage(commonMessages.quantity), ": ").concat(line.quantity))))), React.createElement("div", {
    className: "cart-table-row__data-actions"
  }, React.createElement("div", {
    className: "left"
  }, React.createElement(Button, {
    className: "red"
  }, React.createElement("div", null, intl.formatMessage(_defineProperty({
    defaultMessage: "instructions",
    "id": "components.CartTable.ProductRow.3995487368"
  }, "id", "components.CartTable.ProductRow.3995487368"))), React.createElement(ReactSVG, {
    path: downloadImg
  }))), React.createElement("div", {
    className: "right"
  }, React.createElement(Link, {
    to: reviewsUrl
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "+ Add review",
    "id": "components.CartTable.ProductRow.3562725269"
  }, "id", "components.CartTable.ProductRow.3562725269"))), React.createElement(Link, {
    to: editUrl
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "See product",
    "id": "components.CartTable.ProductRow.222143520"
  }, "id", "components.CartTable.ProductRow.222143520")))))), React.createElement("div", {
    className: "cart-table-row__border"
  }));
};

export default ProductRow;